import * as routes from './routes';

import type { AppModule } from '@/core/register-modules';

export const AuthModule: AppModule = { routes };
